export const MAXIMUM_TIMEOUT_THRESHOLD_MS = 1000 * 60 * 60; // 1 hour

export function exponentialBackoffThreshold(requestCount: number): number {
  const calculatedTimeoutThreshold = requestCount ** 2 * 1000;
  return Math.min(calculatedTimeoutThreshold, MAXIMUM_TIMEOUT_THRESHOLD_MS);
}
